App.controller('UserCreateCtrl', UserCreateCtrl);

UserCreateCtrl.$inject = [
    'DialogService',
    'userFactory'
];

function UserCreateCtrl(DialogService, userFactory) {
    var vm = this;

    vm.user = {
        name:   '',
        email:  ''
    };

    vm.create = create;

    function create() {
        userFactory.create(vm.user).then(function() {
            DialogService.success(
                'They should be receiving an email to create their password shortly',
                'Success! User Created',
                function() {
                    location.href = '#/users';
                }
            );
        });
    }
}